import React from 'react';

export type KeyboardEventPredicate = (
  e: KeyboardEvent | React.KeyboardEvent
) => boolean;

const isKey =
  (key: string, ieKey?: string): KeyboardEventPredicate =>
  (e: KeyboardEvent | React.KeyboardEvent) =>
    e.key === key || (!!ieKey && e.key === ieKey);

const isCode =
  (code: string): KeyboardEventPredicate =>
  (e) =>
    e.code === code;

export const isArrowDownKey = isKey('ArrowDown', 'Down');
export const isArrowUpKey = isKey('ArrowUp', 'Up');
export const isArrowRightKey = isKey('ArrowRight', 'Right');
export const isArrowLeftKey = isKey('ArrowLeft', 'Left');
export const isBackspaceKey = isKey('Backspace');
export const isCapsLockKey = isKey('CapsLock');
export const isDeleteKey = isKey('Delete', 'Del');
export const isEnterKey = isKey('Enter');
export const isShiftKey = isKey('Shift');
export const isSpaceKey = isKey(' ');
export const isEscapeKey = isKey('Escape', 'Esc');

export const isArrowKey: KeyboardEventPredicate = (e) =>
  isArrowDownKey(e) ||
  isArrowUpKey(e) ||
  isArrowRightKey(e) ||
  isArrowLeftKey(e);
export const isControlKeyOn: KeyboardEventPredicate = (e) => e.ctrlKey;
export const isCommandKeyOn: KeyboardEventPredicate = (e) => e.metaKey;
export const isShiftKeyOn: KeyboardEventPredicate = (e) => e.shiftKey;
export const isAltKeyOn: KeyboardEventPredicate = (e) => e.altKey;
export const isCommandOrControlKeyOn: KeyboardEventPredicate = (e) =>
  isCommandKeyOn(e) || isControlKeyOn(e);

export const isCtrlSKey = (e: KeyboardEvent | React.KeyboardEvent) =>
  isCommandOrControlKeyOn(e) && isCode('KeyS')(e);
